import React from 'react';
import { MessageCircle, Send } from 'lucide-react';

export default function ChatView({ chatMessages, chatInput, setChatInput, chatStatus, chatError, sendChatMessage, chatEndRef, username }) {
  return (
    <>
      <header className="library-header">
        <div className="library-icon"><MessageCircle /></div>
        <h2 style={{ flex: 1 }}>Global Chatt</h2>
        <span style={{ color: chatStatus === 'connected' ? 'var(--primary)' : 'var(--text-secondary)', fontSize: '13px' }}>
          {chatStatus === 'connected' ? '● Ansluten' : chatStatus === 'connecting' ? '● Ansluter...' : '● Frånkopplad'}
        </span>
      </header>
      <div style={{
        display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0,
        width: '95%', margin: '0 auto', background: 'var(--bg-surface)',
        borderRadius: 'var(--radius-md)', overflow: 'hidden', border: '1px solid var(--border-color)'
      }}>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {chatError && <div style={{ color: '#ff8080', fontSize: '13px' }}>{chatError}</div>}
          {chatMessages.map((msg, i) => (
            <div key={msg.id || `${msg.username}-${msg.created_at}-${i}`} style={{
              display: 'flex', flexDirection: 'column',
              alignItems: msg.username === username ? 'flex-end' : 'flex-start'
            }}>
              <div style={{
                background: msg.username === username ? 'var(--primary)' : 'var(--bg-surface-hover)',
                color: msg.username === username ? 'black' : 'white',
                padding: '8px 14px', borderRadius: '12px', maxWidth: '70%', fontSize: '14px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}>
                <div style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '4px', opacity: 0.8 }}>{msg.username}</div>
                {msg.message}
              </div>
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>
        <form onSubmit={sendChatMessage} style={{
          display: 'flex', padding: '15px', gap: '10px',
          background: 'var(--bg-deep)', borderTop: '1px solid var(--border-color)'
        }}>
          <input
            type="text" value={chatInput} onChange={e => setChatInput(e.target.value)}
            placeholder="Skriv ett meddelande..."
            style={{
              flex: 1, background: 'var(--bg-surface)', border: '1px solid var(--border-color)',
              borderRadius: 'var(--radius-full)', padding: '10px 20px', color: 'white', outline: 'none'
            }}
          />
          <button type="submit" className="chat-send-button" style={{
            background: 'var(--primary)', color: 'black', border: 'none',
            borderRadius: 'var(--radius-full)', padding: '0 20px', fontWeight: 'bold', cursor: 'pointer'
          }} disabled={chatStatus !== 'connected'}><Send size={17} /> Skicka</button>
        </form>
      </div>
    </>
  );
}
